import { useEffect, useState } from "react";
import { SignIn } from "./SignIn";
import { SignUp } from "./SignUp";
import { ForgotPassword } from "./ForgotPassword";
import { ResetPassword } from "./ResetPassword";

export function Auth({ method }) {
  const [auth, setAuth] = useState(method || "sign-in");

  useEffect(() => {
    if (window.location.pathname === "/") window.location.pathname = "sign-in";
  }, []);

  if (auth === "forgot-password") {
    return (
      <ForgotPassword
        setAuth={setAuth}
      />
    );
  }

  if (auth === "reset-password") {
    return (
      <ResetPassword
        setAuth={setAuth}
      />
    );
  }

  if (auth === "sign-up") {
    return (
      <SignUp
        setAuth={setAuth}
      />
    );
  }

  return (
    <SignIn
      setAuth={setAuth}
    />
  );
}
